import { useState, useEffect } from "react";
import { fetchAppConfig } from "./loadConfig";

export default function useConfig() {
  const [config, setConfig] = useState(null);

  useEffect(() => {
    let isMounted = true;
    fetchAppConfig()
      .then((cfg) => {
        if (isMounted) setConfig(cfg);
      })
      .catch((err) => {
        console.error("Error loading config", err);
      });

    return () => {
      isMounted = false;
    };
  }, []);

  return config;
}
